/**
 * 忘記密碼 / 重設密碼 schema — REQ-20260418010。
 */
import { z } from 'zod';

export const ForgotPasswordSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
});
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordSchema>;

/** 至少 8 碼、包含英數各一（與 user.schema 密碼規則對齊；忘了密碼不需舊密碼） */
export const ResetPasswordSchema = z.object({
  token: z.string().min(32).max(128),
  newPassword: z
    .string()
    .min(8, '密碼至少 8 碼')
    .max(72, '密碼最長 72 碼')
    .regex(/[A-Za-z]/, '密碼須包含英文字母')
    .regex(/[0-9]/, '密碼須包含數字'),
});
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;

export const IssueResetLinkSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
});
export type IssueResetLinkInput = z.infer<typeof IssueResetLinkSchema>;

export const IssueResetLinkResponseSchema = z.object({
  resetUrl: z.string().url(),
  expiresAt: z.string().datetime(),
});
export type IssueResetLinkResponse = z.infer<typeof IssueResetLinkResponseSchema>;
